import React from "react";
import DisplayComponent from "./DisplayComponent";
import {
  getAvailablePlates,
  getBarAndCollarsWeight,
  getPlates,
} from "util/barLoad";
import { getMeetUnits } from "util/meetHelper";
import { Attempt, Lifter, LiftingOrder, Meet, Platform } from "types";
import get from "lodash/get";
import uniqBy from "lodash/uniqBy";
import groupBy from "lodash/groupBy";
import truncate from "lodash/truncate";
import map from "lodash/map";

const NextLoad = ({
  meet,
  liftingOrder,
  currentAttempt,
  currentLifter,
  id,
  platform,
}: {
  meet: Meet;
  liftingOrder: LiftingOrder;
  currentAttempt: Attempt;
  currentLifter: Lifter | undefined;
  id: string;
  platform: Platform;
}) => {
  const firstAttemptInOrder = get(liftingOrder, [0, "attempt"]);

  let nextAttempt = get(liftingOrder, [1, "attempt"]);
  let nextLifter = get(liftingOrder, [1, "lifter"]);

  if (
    currentAttempt?._id &&
    firstAttemptInOrder?._id &&
    currentAttempt._id !== firstAttemptInOrder._id
  ) {
    nextAttempt = firstAttemptInOrder;
    nextLifter = get(liftingOrder, [0, "lifter"]);
  }

  if (!nextAttempt) {
    nextAttempt = { weight: 200 } as Attempt;
  }
  let isError = false;
  let plates;
  const availablePlates = getAvailablePlates(meet.plates);
  try {
    plates = getPlates({
      weight: nextAttempt.weight as number,
      availablePlates,
      platform,
      lifter: nextLifter,
      attempt: nextAttempt,
    });
  } catch (e) {
    isError = true;
  }

  const plateCounts = groupBy(plates, (plate) => {
    return plate.weight;
  });

  plates = uniqBy(plates, (plate) => {
    return plate.weight;
  });

  const currentBarAndCollarsWeight = getBarAndCollarsWeight({
    attempt: currentAttempt,
    lifter: currentLifter,
    platform,
  });

  const nextBarAndCollarsWeight = getBarAndCollarsWeight({
    attempt: nextAttempt,
    lifter: nextLifter,
    platform,
  });

  return (
    <DisplayComponent id={id} style={{ top: 575, left: 0 }}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        if (isError) {
          return (
            <div style={{ color: "red", fontSize: 18 * sizeMultiplier }}>
              Unable to load {nextAttempt.weight} {meet.units} with available
              plates.
            </div>
          );
        }

        const style = {
          padding: sizeMultiplier * 12,
          fontSize: sizeMultiplier * 24,
          width: sizeMultiplier * 800,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          whiteSpace: "nowrap",
        } as const;

        const liftName = get(nextAttempt, "liftName");
        const rackHeight = get(nextLifter, `${liftName}RackHeight`, "");
        const lifterName = truncate(
          get(nextLifter, "name", "XXXXXXX XXXXXXX"),
          { length: 18, omission: "..." },
        );

        return (
          <div style={style}>
            NEXT • {lifterName}
            {currentBarAndCollarsWeight !== nextBarAndCollarsWeight && (
              <> • Change Bar+Collars to {nextBarAndCollarsWeight} </>
            )}
            • {rackHeight ? `R: ${rackHeight} • ` : ""} {nextAttempt.weight}
            {getMeetUnits(meet)}
            &nbsp;•&nbsp;
            {currentAttempt.weight !== nextAttempt.weight ||
            currentBarAndCollarsWeight !== nextBarAndCollarsWeight ? (
              map(plates, (plate, index) => {
                return (
                  <span key={index}>
                    {index !== 0 && <>&nbsp;-&nbsp;</>}
                    {plate.weight}
                    {plateCounts[plate.weight].length > 1 && (
                      <span>({plateCounts[plate.weight].length})</span>
                    )}
                  </span>
                );
              })
            ) : (
              <span>&nbsp;- SAME WEIGHT</span>
            )}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default NextLoad;
